export var DocsBlockImagePropertyWidth;
(function (DocsBlockImagePropertyWidth) {
    /** Default. Translates to width: 100% */
    DocsBlockImagePropertyWidth["full"] = "Full";
    /** width: 48px */
    DocsBlockImagePropertyWidth["icon"] = "Icon";
    /** width: 120px */
    DocsBlockImagePropertyWidth["small"] = "Small";
    /** width: 180px */
    DocsBlockImagePropertyWidth["medium"] = "Medium";
    /** width: 360px */
    DocsBlockImagePropertyWidth["large"] = "Large";
    /** width: 480px */
    DocsBlockImagePropertyWidth["poster"] = "Poster";
})(DocsBlockImagePropertyWidth || (DocsBlockImagePropertyWidth = {}));
